import { Link, Outlet, createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { auth } from '@/lib/auth'
import { useAuth } from '@/lib/useAuth'
import { Button } from '@/components/ui'

/**
 * Layout prihlasene casti aplikace.
 *
 * `beforeLoad` je jedina branka: kdyz tu neni token, cesty pod `_app` se
 * vubec nezacnou nacitat. Backend si autorizaci hlida sam — tohle je jen
 * proto, aby uzivatel nekoukal na prazdnou obrazovku s 401.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/login', search: { redirect: location.href } })
    }
  },
  component: AppLayout,
})

function AppLayout() {
  const { user } = useAuth()
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-x-6 gap-y-2 px-4 py-3">
          <Link to="/dashboard" className="text-lg font-bold text-brand-700">
            monitoring
          </Link>
          <nav className="flex items-center gap-1">
            <Link
              to="/dashboard"
              className="rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100"
              activeProps={{ className: 'rounded-lg px-3 py-2 text-sm font-medium bg-brand-600 text-white' }}
            >
              Prehled
            </Link>
          </nav>
          <div className="ml-auto flex items-center gap-3">
            <span className="hidden text-sm text-slate-500 sm:inline">{user?.email}</span>
            <Button
              variant="ghost"
              onClick={() => {
                auth.logout()
                navigate({ to: '/login' })
              }}
            >
              Odhlasit
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  )
}
